import logo_xlsx from "../../Assets/svg/logo_xlsx.svg"
import { useSelector } from "react-redux";
import { data_types } from "../../App/validation/data_types";
import writeXlsxFile from "write-excel-file";

export default function DownloadExcelNestedTable(){
    const layer = useSelector(state => state.layer)

    const handleDownloadExcel = async () => {
        try {
            const language = localStorage.getItem("language")
            const {is_nested_table_filtered, filtered_childs_shown, child_fields_shown, field_parent, layer_id, geo_layer_list} = layer || false
            const parent_uuid = field_parent?.uuid

            const filtered_childs_shown_properties = filtered_childs_shown?.map((child) => child?.properties)
            const child_fields_shown_properties = child_fields_shown?.map((child) => child?.properties)

            let geo_layer = geo_layer_list.find((e) => e?.geo_layer?._id === layer_id)
            geo_layer = geo_layer?.geo_layer ? geo_layer?.geo_layer : {}
            const selected_cols = geo_layer?.fields?.filter(item => item?.parent_uuid === parent_uuid)
            
            let schema = [
                {
                    column: "No.",
                    type: Number,
                    value: (data) => data.no
                },
                ...selected_cols.map((col) => {
                    const object_type = data_types(language).find(i =>
                        i?.value === col?.type
                    )
                    
                    const {js_data_type, format_date, callback} = object_type || {};

                    return {
                        column: col.name?.trim() ?? "Unnamed",
                        type: js_data_type || String,
                        value: (data) => {
                            let value = data[col.key];

                            // Handle null/undefined
                            if(value === undefined){
                                if(js_data_type === String) return ""
                                if(js_data_type === Date) return ""
                            }

                            if(value === null) {
                                if(js_data_type === Number) return 0;
                                if(js_data_type === Date) return null;
                                return "";
                            }

                            if(callback){
                                return callback(value)
                            }

                            // Konversi tipe dasar
                            if(js_data_type === Number){
                                const num = Number(value)
                                return isNaN(num) ? 0 : num
                            }

                            if(js_data_type === Date){
                                const date = new Date(value);
                                return isNaN(date.getTime()) ? null : date
                            }

                            return String(value).trim()
                        },
                        ...(format_date && js_data_type === Date ? {format: format_date} : {})
                    }
                })
            ]

            // const keys = selected_cols.map((col) => col.key)
            let newData = is_nested_table_filtered ? filtered_childs_shown_properties : child_fields_shown_properties
            
            await writeXlsxFile(newData, {
                schema,
                fileName: geo_layer.name
            })
        } catch (error) {
            
        }
    }

    return (
        <button 
            className="button_big button_white outline_shadow_soft"
            onClick={handleDownloadExcel}
        >
            <img src={logo_xlsx} width={40} alt="icon download xlsx"/>
        </button>
    )
}